<template>
  <div>
      <v-row class="content">
        <v-col class="pa-0 col">
          <v-carousel class="slider" height="100%" hide-delimiters >
            <v-carousel-item style="max-height: 47vh;" v-for="(fotos,i) in propiedad.fotos" :key="i" 
              reverse-transition="fade-transition" transition="fade-transition">
              <v-img alt="Fotos de propiedad" :src="`${fotos}`" style="width: 100%; max-height: 48vh;"></v-img>
            </v-carousel-item>
          </v-carousel>
        </v-col>
        <v-col class="borde">
          <div style="height: 25%; display:flex;">
            <span v-if="(propiedad.comprar)?this.operacion='VENTA':this.operacion='ALQUILER'" 
            class="operacion my-auto white--text">{{operacion}}</span>
            <span class="pt-3 ml-0 pl-0" style="width: 85%; height: 25%; display: flex; justify-content: space-around;">
              <span v-show="(propiedad.habitacion==0) ? false:true" style="color: #97b699;"> 
                {{propiedad.habitacion}} <v-icon  color="#97b699" x-large>mdi-bed</v-icon> </span>
              <span v-show="(propiedad.baño==0) ? false:true" style="color: #97b699;"> 
                {{propiedad.baño}} <v-icon style="color: #97b699;" x-large>mdi-shower</v-icon> </span>
              <div v-show="(propiedad.mts) ? true:false" class="mx-3 alinear"> 
                <v-icon class="mt-4 mr-2" size="50px" color="#97b699">mdi-ruler</v-icon> 
                <span style="color: #97b699;">{{propiedad.mts}}<p>M²</p></span>
              </div>
            </span>
          </div>
          
          <div class="mt-2" style="height: 50%;">
            <p class="texto" style="text-align: justify;">{{propiedad.desc}}</p>
          </div>
          <div class="alinear" style="height: 25%;">
            <span style="margin: auto 10%;">
              <h3 class="responsive">COD. {{propiedad.codigo}}</h3>
              <h3 class="responsive" style="color: #97b699;">USD {{propiedad.precio}}</h3>
            </span>
            <v-spacer></v-spacer>
            <span class="masInfo">
              <v-btn @click="ficha" color="#97b699" style="color: white; border-radius: 0.5rem;">
                Más info >
              </v-btn>
            </span>
          </div>
        </v-col>
      </v-row>
    </div>
</template>

<script>

export default {
  name: 'PropiedadC',
  props: ['propiedad'],
  operacion: '',

  data: () => ({
    //
  }),
  methods: {
    ficha() {
      this.$router.push({ name: 'FichaC', params: {propiedad: this.propiedad}})
    }
  },
  /* mounted () {
    console.log(this.propiedad.fotos)
  } */
};
</script>

<style scoped>
  .operacion{
    width: 15%; 
    height: 25px; 
    background-color: #97b699;
    padding-left: 12px;
  }
  .content{
    margin: 1rem 15%;
  }
  .masInfo{
    margin-right: 10%;
    margin-top: 10px;
  }
  .col{
    max-width: 475px;
    max-height: 267px;
  }
  @media screen and (max-width: 700px){
    .content{
      margin: 1rem 5%;
    }
    .col{
      max-height: 215px;
    }
    .operacion{
      font-size: medium;
      padding-left: 2px;
    }
  }
  @media screen and (max-width: 375px){
    .responsive{
      font-size:medium;
    }
    .operacion {
      font-size: small;
    }
  }
  @media screen and (max-width: 320px){
    .responsive{
      font-size:small;
    }
  }
</style>